<template>
  <div class="page withdraw-protocol">
    <navigation  >相关协议</navigation>

    <nd-cell class="navigate-item"
             v-for="(item, index) in protocolList"
             :key="index"
             :title="item.title"
             @click="pdfProtocol(item)"
    >
    </nd-cell>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getKey } from '@/assets/utils'

export default {
  name: 'withdraw-protocol',

  customReadyNotify: true,

  description: '提现相关协议',

  data () {
    return {
      protocolList: []
    }
  },

  async created () {
    try {
      await this.getProtocolList()
      this.$bus.$emit('ready')
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },

  methods: {
    ...mapActions('apiDiversion', ['agreement']),

    async getProtocolList () {
      const response = await this.agreement({
        configIds: this.$route.query.configIds || getKey('configIds'),
        busiType: this.$route.query.busiType || 'CREDIT'
      })
      if (response.success) {
        this.protocolList = response.data
      }
    },
    pdfProtocol (item) {
      if (item.urlShowType === 'PDF_HTTP') {
        // this.$router.push({ path: '/protocol/pdf', query: { file: item.path, title: item.title } })
        const origin = process.env.VUE_APP_PROURL
        const gid = getKey('gid')
        const { mobile, userId } = getKey('userInfo') || {}
        window.location.href = `${origin}/protocol/src2pdf?file=${item.path}&title=${item.title}&gid=${gid}&userId=${userId}&phoneNumber=${mobile}`
      } else {
        window.location.href = item.path
      }
    },
    clickProtocol (item) {
      window.location.href = item.path
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.withdraw-protocol {
    background-color: #fafafa;

      .navigate-item {
          height: 110px;
          line-height: 1.5;
          margin-top: 0px;
          padding-left: 15px;
          padding-right: 17px;
          border-bottom: 1px solid @iuc;
      }
}
</style>

